var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletDefaultLight = function SvgIcWalletDefaultLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_default_light_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.767 7.28a.703.703 0 0 1 0 1.377l-.142.015H10.078a2.109 2.109 0 0 0-2.08 1.766c.407-.229.877-.36 1.377-.36h11.25a2.813 2.813 0 0 1 2.813 2.813v7.03a2.813 2.813 0 0 1-2.813 2.813H9.375a2.813 2.813 0 0 1-2.813-2.812v-9.14a3.516 3.516 0 0 1 3.516-3.516h10.547l.142.014Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 16.5,
    r: 1.5,
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_default_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
};
export default SvgIcWalletDefaultLight;